const updates = [
  {
    date: '2026年7月31日',
    title: '《长安诡事录》大结局上线',
    desc: '热门古装悬疑剧迎来大结局，全集已更新完毕，快来一口气追完。',
  },
  {
    date: '2026年7月30日',
    title: '天美麻花专区新增三部独家电影',
    desc: '天美麻花星空影视免费观看专区更新三部高分独家影片，限时上线。',
  },
  {
    date: '2026年7月29日',
    title: '暑期档观影指南专题上线',
    desc: '2026暑期热门影片全收录专题页面上线，囊括院线大片和网络热播剧。',
  },
  {
    date: '2026年7月28日',
    title: '《星际救援》蓝光高清版更新',
    desc: '好莱坞科幻巨制蓝光版上线，1080P高清免费在线观看已全面开放。',
  },
  {
    date: '2026年7月27日',
    title: '播放线路全面升级',
    desc: '新增多条高速播放线路，全国用户均可享受更流畅的高清观影体验。',
  },
  {
    date: '2026年7月26日',
    title: '韩剧《她的秘密花园》全集更新',
    desc: '近期热播韩剧全集上线，高清韩语中字版免费追剧平台已同步更新。',
  },
  {
    date: '2026年7月25日',
    title: '纪录片频道改版上线',
    desc: '纪录片库页面全新改版，自然、历史、科技、人文四大分类更清晰。',
  },
  {
    date: '2026年7月24日',
    title: '《功夫世家》动作喜剧热映中',
    desc: '年度动作喜剧口碑之作上线，高清画质带来淋漓尽致的功夫视觉盛宴。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3 whitespace-nowrap">
            更新动态
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            平台最新动态
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            关注91影视看片下载最新资源更新与平台动态，追剧快人一步
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-[11px] md:left-[15px] top-2 bottom-2 w-0.5 bg-background-200"></div>
            {updates.map((update, idx) => (
              <div key={idx} className="relative pb-8 last:pb-0">
                <div className="absolute left-[-22px] md:left-[-25px] top-1 w-3 h-3 rounded-full bg-accent-500 border-2 border-background-100 z-10"></div>
                <div className="bg-background-50 rounded-xl p-4 md:p-5">
                  <span className="text-foreground-400 text-xs mb-2 block">{update.date}</span>
                  <h4 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-1">
                    {update.title}
                  </h4>
                  <p className="text-foreground-600 text-sm leading-relaxed">{update.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}